export enum ResourceCharacteristicTypeBounds {
  Unbounded = 1,
  LowerBounded = 2,
  UpperBounded = 3
}
